export const MIN_PLAYERS = 1;
export const MAX_PLAYERS = 4;
export const COOP_ENEMY_BONUS = 0.35;

export const normalizePlayerCount = (players: number): number =>
  Math.max(MIN_PLAYERS, Math.min(MAX_PLAYERS, Math.round(players) || MIN_PLAYERS));

export const getEnemyMultiplier = (players: number): number =>
  1 + (normalizePlayerCount(players) - 1) * COOP_ENEMY_BONUS;

export const getScaledEnemyCount = (baseCount: number, players: number): number =>
  Math.max(baseCount, Math.round(baseCount * getEnemyMultiplier(players)));
